import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { slug } from "../lib/store";

const TILES = [
  { cat: "Wine", img: "/img/cellar.jpg", line: "Old world, new world, Sussex fizz.", span: "md:col-span-2 lg:col-span-7 lg:row-span-2", big: true },
  { cat: "Spirits", img: "/img/spirits2.jpg", line: "Malts, gins, rums worth sipping.", span: "lg:col-span-5 lg:row-span-2", big: true },
  { cat: "Beer & Cider", img: "/img/beer.jpg", line: "Local craft & fridge-cold lager.", span: "lg:col-span-4" },
  { cat: "Soft drinks", img: "/img/soft.jpg", line: "Mixers, colas, sparkling.", span: "lg:col-span-4" },
  { cat: "Snacks", img: "/img/snacks.jpg", line: "Crisps, sweets, nibbles.", span: "lg:col-span-4" },
];

const Tile = ({ t, i, onPick }) => (
  <Reveal delay={i * 0.06} className={`${t.span} min-h-[260px]`}>
    <motion.button whileHover="hover" data-testid={`guna-bento-${slug(t.cat)}`} onClick={() => onPick(t.cat)}
      className="group relative h-full w-full overflow-hidden rounded-2xl border border-black/10 bg-[#1C1917] text-left">
      <motion.img src={t.img} alt={t.cat} variants={{ hover: { scale: 1.08 } }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
      <div className="relative flex h-full flex-col justify-between p-6 md:p-8">
        <span className="font-mono-g text-xs text-[#FFC93C]">0{i + 1}</span>
        <div className="flex items-end justify-between gap-4">
          <div>
            <h3 className={`font-display text-white ${t.big ? "text-5xl md:text-7xl" : "text-4xl"}`}>{t.cat}</h3>
            <p className="mt-2 text-sm text-white/85">{t.line}</p>
          </div>
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-white/40 text-white transition-colors duration-300 group-hover:bg-[#FFC93C] group-hover:text-[#1C1917]">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>
      </div>
    </motion.button>
  </Reveal>
);

export const Bento = ({ onPick }) => (
  <section id="shelves" className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
    <SectionHead kicker="The shelves" title={<>Walk the aisles <em className="text-[#D62828]">online.</em></>}>
      <p className="max-w-xs text-stone-700">Tap a shelf to jump straight to it in the catalogue.</p>
    </SectionHead>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:auto-rows-[260px] lg:grid-cols-12 md:gap-5">
      {TILES.map((t, i) => <Tile key={t.cat} t={t} i={i} onPick={onPick} />)}
    </div>
  </section>
);
